import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "multi-block__menu-outline" }
const _hoisted_2 = { class: "multi-block__menu-outline" }

import ListingBlock from '@/app/components/listing/ListingBlock.vue'
import CustomListMenu from '@/app/components/custom.lists/CustomListMenu.vue'
import EmptyListingBlock from '@/app/components/listing/EmptyListingBlock.vue'

import type { ListView } from '@/models/docs.list'
import type { CustomList, ListItem } from '@/models/interfaces'
import { CustomListsView } from '@/models/custom.lists'


export default /*@__PURE__*/_defineComponent({
  __name: 'MultiDocsBlock20321',
  props: {
    view: {},
    docViewEventProperties: {},
    customList: {},
    customListsView: {},
    showFreeBooks: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.view.hasDocs())
    ? (_openBlock(), _createBlock(ListingBlock, {
        key: 0,
        class: "multi-block",
        view: __props.view,
        docs: __props.view.docs().filteredDocs.slice(0, 4),
        cardProps: { showFreeBooks: __props.showFreeBooks },
        docViewEventProperties: __props.docViewEventProperties
      }, _createSlots({ _: 2 }, [
        (__props.customList)
          ? {
              name: "headerActions",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (!__props.customList.is_standard)
                    ? (_openBlock(), _createBlock(CustomListMenu, {
                        key: 0,
                        list: __props.customList,
                        listsView: __props.customListsView,
                        position: "right"
                      }, null, 8, ["list", "listsView"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["view", "docs", "cardProps", "docViewEventProperties"]))
    : (_openBlock(), _createBlock(EmptyListingBlock, {
        key: 1,
        class: "multi-block",
        title: __props.view.pageTitle()
      }, _createSlots({
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("p", null, [
            _createTextVNode(" Documents you add to this list will appear here. To add a book, article, or podcast episode, click on the "),
            _createElementVNode("span", { class: "iconfont iflag2" }),
            _createTextVNode(" icon on the card, then on \"Add to List\" and select the list. ")
          ], -1))
        ]),
        _: 2
      }, [
        (__props.customList)
          ? {
              name: "headerActions",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (!__props.customList.is_standard)
                    ? (_openBlock(), _createBlock(CustomListMenu, {
                        key: 0,
                        list: __props.customList,
                        listsView: __props.customListsView,
                        position: "right"
                      }, null, 8, ["list", "listsView"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["title"]))
}
}

})